module.exports = __webpack_public_path__ + "img/hacker.c7a4d4f0.jpeg";